import {View} from '@unthinkable/react-core-components';
import styled from 'styled-components';

export const AuthenticatorContainer = styled(View)`
  align-items: center;
  gap: 4px;
`;
